import { useState } from 'react'
import { Modal } from '../Common/Modal'
import { Button } from '../Common/Button'

export function TransactionForm({ initialData, onSave, onClose, sidebarCollapsed, isDarkMode = false }) {
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  const [formData, setFormData] = useState({
    transaction_date:     initialData?.transaction_date?.slice(0, 10) || '',
    statement_date:       initialData?.statement_date?.slice(0, 10) || '',
    policy_invoice_no:    initialData?.policy_invoice_no || '',
    client:               initialData?.client || '',
    product:              initialData?.product || '',
    advisor_split:        initialData?.advisor_split ?? '',
    supplier_amount_excl: initialData?.supplier_amount_excl ?? '',
    supplier_amount_vat:  initialData?.supplier_amount_vat ?? '',
    advisor_share_excl:   initialData?.advisor_share_excl ?? '',
    advisor_share_vat:    initialData?.advisor_share_vat ?? '',
    advisor_share_inc:    initialData?.advisor_share_inc ?? '',
    active:               initialData?.active ?? true,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSaving(true)
    try {
      const payload = {
        ...formData,
        transaction_date:     formData.transaction_date || null,
        statement_date:       formData.statement_date || null,
        policy_invoice_no:    formData.policy_invoice_no || null,
        advisor_split:        formData.advisor_split !== '' ? Number(formData.advisor_split) : null,
        supplier_amount_excl: formData.supplier_amount_excl !== '' ? Number(formData.supplier_amount_excl) : null,
        supplier_amount_vat:  formData.supplier_amount_vat !== '' ? Number(formData.supplier_amount_vat) : null,
        advisor_share_excl:   formData.advisor_share_excl !== '' ? Number(formData.advisor_share_excl) : null,
        advisor_share_vat:    formData.advisor_share_vat !== '' ? Number(formData.advisor_share_vat) : null,
        advisor_share_inc:    formData.advisor_share_inc !== '' ? Number(formData.advisor_share_inc) : null,
      }
      await onSave(payload)
    } catch (err) {
      setError(err.message)
    } finally {
      setSaving(false)
    }
  }

  const field = (label, name, type = 'text', placeholder = '') => (
    <div>
      <label htmlFor={name} className="block text-sm font-medium mb-1" style={{ color: isDarkMode ? '#e2e8f0' : '#333333' }}>{label}</label>
      <input
        id={name}
        name={name}
        type={type}
        value={formData[name]}
        onChange={handleChange}
        className="input-field w-full"
        placeholder={placeholder}
        step={type === 'number' ? 'any' : undefined}
      />
    </div>
  )

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={initialData ? 'Edit Transaction' : 'Add Transaction'}
      sidebarCollapsed={sidebarCollapsed}
      isDarkMode={isDarkMode}
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {error && <p className={isDarkMode ? 'text-red-400' : 'text-red-500'} style={{ fontSize: '0.875rem' }}>{error}</p>}

        <div className="grid grid-cols-2 gap-4">
          {field('Transaction Date', 'transaction_date', 'date')}
          {field('Statement Date', 'statement_date', 'date')}
        </div>

        <div className="grid grid-cols-2 gap-4">
          {field('Policy Invoice No.', 'policy_invoice_no', 'text', 'e.g. 818296')}
          {field('Client', 'client', 'text', 'Client name')}
        </div>

        <div className="grid grid-cols-2 gap-4">
          {field('Product', 'product', 'text', 'e.g. Commercial')}
          {field('Advisor Split %', 'advisor_split', 'number', 'e.g. 20')}
        </div>

        <div className="grid grid-cols-3 gap-4">
          {field('Supplier Excl', 'supplier_amount_excl', 'number')}
          {field('Supplier VAT', 'supplier_amount_vat', 'number')}
          <div /> {/* spacer */}
        </div>

        <div className="grid grid-cols-3 gap-4">
          {field('Advisor Share Excl', 'advisor_share_excl', 'number')}
          {field('Advisor Share VAT', 'advisor_share_vat', 'number')}
          {field('Advisor Share Inc', 'advisor_share_inc', 'number')}
        </div>

        <div className="flex items-center justify-between pt-2">
          <span className="text-sm font-medium" style={{ color: isDarkMode ? '#e2e8f0' : '#333333' }}>Active</span>
          <button
            type="button"
            onClick={() => setFormData(p => ({ ...p, active: !p.active }))}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${formData.active ? 'bg-sfp-orange' : 'bg-gray-300'}`}
          >
            <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${formData.active ? 'translate-x-6' : 'translate-x-1'}`} />
          </button>
        </div>

        <div className="flex gap-2 justify-end pt-4" style={{ borderTop: `1px solid ${isDarkMode ? '#475569' : '#e5e7eb'}` }}>
          <Button variant="secondary" type="button" onClick={onClose} disabled={saving}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving ? 'Saving...' : initialData ? 'Update' : 'Save Transaction'}
          </Button>
        </div>
      </form>
    </Modal>
  )
}
